import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TagManager from "react-gtm-module";
import { GTM_ID, GTM_ID_STAGING } from "@/utils/constants";
import { initializeGTM } from "@/utils/gtm";
import { logger } from "@/utils/logger";
import { getStoredUtms, pushUtmsToDataLayer } from "@/utils/utm";

export default function GTMProvider() {
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    const isProduction = hostname === "lexi.tips";
    const gtmId = isProduction ? GTM_ID : GTM_ID_STAGING;

    // logger.log("GTM Debug:", {
    //   hostname,
    //   isProduction,
    //   gtmId,
    //   stagingId: GTM_ID_STAGING,
    //   prodId: GTM_ID,
    // });

    if (gtmId) {
      TagManager.initialize({
        gtmId,
        dataLayer: {
          environment:
            hostname === "localhost"
              ? "development"
              : hostname === "staging.lexi.tips"
                ? "staging"
                : "production",
          debug: !isProduction,
          // Make persisted utm_* available to GTM as Data Layer Variables in
          // the initial push, before the container loads.
          ...getStoredUtms(),
        },
      });
    } else {
      // logger.error("GTM ID not found");
    }
  }, []);

  useEffect(() => {
    if (location.pathname) {
      // Re-push persisted utm_* on each SPA route change so post-login page
      // views (where the URL no longer carries them) still expose them to GTM.
      //
      // ORDERING CONSTRAINT: GTM's History Change trigger fires synchronously
      // on pushState, before this effect runs, so this push lands AFTER GTM's
      // page_view for the navigation. The UTMs are therefore only reliably
      // available to GTM as Data Layer Variables (read on a later event/tag),
      // NOT to the page_view fired on the same route change. The initial
      // TagManager.initialize() push above is not affected. This is why the
      // relevant GTM variables must be configured as Data Layer Variables for
      // post-login page views to pick up utm_content.
      pushUtmsToDataLayer();
    }
  }, [location]);

  return (
    // Add GTM noscript iframe for better tracking
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      />
    </noscript>
  );
}
